import useGetMyRegionPreferences from '@/api/queries/me/useGetMyRegionPreferences';
import {
  DateFormats,
  getInternationalDateFormatByLocale,
} from '@payaca/helpers/internationalHelper';

const usePreferredDateFormat = (dateFormat: DateFormats) => {
  const { data: accountRegionPreferences } = useGetMyRegionPreferences();

  return getInternationalDateFormatByLocale(
    dateFormat,
    accountRegionPreferences?.locale
  );
};

export default usePreferredDateFormat;
